<template>
  <div class="uc-Exam-box" @contextmenu.prevent>
    <section class="g-headerExam">
      <div class="container">
        <div class="row">
          <div class="col-24 box">
            <router-link to="/" class="logo"
              ><img src="../../assets/images/logo.png"
            /></router-link>
            <div class="title">
              {{ model.name }}
            </div>
            <div class="time-box" v-if="model.duration > 0">
              <img src="../../assets/images/time.png" class="uc-icon44" />{{
                remainder
              }}
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="g-headerExamSpace"></div>

    <section class="container-fluid g-ExamPercentBox">
      <div class="container">
        <div class="col-24 box">
          <div class="name">姓名：{{ $store.getters.user.first_name }}</div>
          <div class="center">
            <div class="number">
              <i class="uc-blue">{{ model.answer_count }}</i
              >/{{ model.question_count }}
            </div>
            <div class="percent">
              <i class="per" :style="`width:${model.answer_percent}%`"></i>
            </div>
          </div>
          <div v-show="showCard" class="btn-card uc-blue" @click="btnShowCard">
            <img
              src="../../assets/images/icon-card-on.png"
              class="uc-icon20"
            />答题卡
          </div>
          <div v-show="!showCard" class="btn-card" @click="btnShowCard">
            <img
              src="../../assets/images/icon-card.png"
              class="uc-icon20"
            />答题卡
          </div>
        </div>
      </div>
    </section>
    <div class="g-ExamPercentBoxSpace"></div>
    <section class="container-fluid uc-alert-ExamCardBox" v-show="showCard">
      <div class="container">
        <div class="tags">
          <div class="tag"><i class="dot blue"></i>已答</div>
          <div class="tag"><i class="dot"></i>未答</div>
        </div>

        <div class="list">
          <div
            class="item"
            v-for="(item, index) in model.question_type_list"
            :key="index"
          >
            <div class="txt">
              {{ item.index }}、{{ item.type_name }} (共{{
                item.question_score
              }}分)
            </div>
            <div class="con">
              <div
                class="sub-item"
                v-for="(item2, index2) in item.question_list"
                :key="index2"
                :class="item2.user_answer_status == 1 ? 'blue' : ''"
                @click="btnCardClick(index, index2)"
              >
                {{ index2 + 1 }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="container-fluid uc-bg uc-Exam">
      <div class="container">
        <div class="list">
          <div v-for="(item, index) in model.question_type_list" :key="index">
            <div
              class="title"
              v-show="
                model.page_mode == 1 ||
                  (model.page_mode == 2 && index == showIndex)
              "
            >
              {{ item.index }}、{{ item.type_name }} (共{{
                item.question_count
              }}道题)
            </div>
            <div v-for="(item2, index2) in item.question_list" :key="index2">
              <div
                class="item"
                :id="`question_${index}_${index2}`"
                v-show="
                  model.page_mode == 1 ||
                    (model.page_mode == 2 &&
                      index == showIndex &&
                      index2 == showIndex2)
                "
              >
                <!-- 非填空题的题干 -->
                <div class="sub-title" v-if="item2.question_type != 4">
                  <span>{{ index2 + 1 }}.</span>
                  <div class="qst-con w-e-text" v-html="item2.content"></div>
                  <small>({{ item2.score }}分)</small>
                </div>
                <!-- 填空题题干 -->
                <div class="input-box" v-if="item2.question_type == 4">
                  <span>{{ index2 + 1 }}.</span>
                  <div class="qst-con w-e-text">
                    <div
                      class="input-item w-e-text"
                      v-for="(item3, index3) in item2.content.split('()')"
                      :key="index3"
                    >
                      <div v-html="item3"></div>
                      <input
                        type="text"
                        class="uc-input uc-w300"
                        v-if="index3 != item2.option_count"
                        v-model.trim="item2.user_answer[index3]"
                        @blur="saveAnswer(item2)"
                      />
                    </div>
                  </div>
                  <small>({{ item2.score }}分)</small>
                </div>
                <!-- 单选题、判断题 -->
                <el-radio-group
                  v-model="item2.user_answer"
                  class="choose-box"
                  v-if="item2.question_type == 1 || item2.question_type == 3"
                  @change="saveAnswer(item2)"
                >
                  <el-radio
                    :label="item3.value"
                    v-for="(item3, index3) in item2.option_list"
                    :key="index3"
                    class="choose-item"
                    >{{ item3.index }}. {{ item3.content }}</el-radio
                  >
                </el-radio-group>
                <!-- 多选题 -->
                <el-checkbox-group
                  v-model="item2.user_answer"
                  class="choose-box"
                  v-if="item2.question_type == 2"
                  @change="saveAnswer(item2)"
                >
                  <el-checkbox
                    :label="item3.value"
                    v-for="(item3, index3) in item2.option_list"
                    :key="index3"
                    class="choose-item"
                    >{{ item3.index }}. {{ item3.content }}</el-checkbox
                  >
                </el-checkbox-group>
                <!-- 问答题 -->
                <div class="textarea-box" v-if="item2.question_type == 5">
                  <textarea
                    class="uc-textarea"
                    placeholder="这里输入你要回答的问题描述"
                    cols="30"
                    rows="10"
                    v-model.trim="item2.user_answer"
                    @blur="saveAnswer(item2)"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="g-footerExam">
      <div class="container">
        <div class="row">
          <div class="col-24 box">
            <button
              @click="btnPrevQuestion"
              class="uc-btn white-plain"
              v-if="model.page_mode == 2"
            >
              上一题
            </button>
            <button
              @click="btnNextQuestion"
              class="uc-btn white-plain"
              v-if="model.page_mode == 2"
            >
              下一题
            </button>
            <button @click="btnShowSubmitSure" class="uc-btn blue uc-ml80">
              交卷
            </button>
          </div>
        </div>
      </div>
    </section>
    <div class="g-footerExamSpace"></div>

    <div class="uc-alert uc-alert-examSubmitSure" v-show="submitSure">
      <div class="over-close"></div>
      <div class="box">
        <div class="con" v-show="model.question_count > model.answer_count">
          您还有{{
            model.question_count - model.answer_count
          }}道题未答（或还有未答项）<br />是否确定交卷？
        </div>
        <div class="con" v-show="model.question_count == model.answer_count">
          所有题目已答，确定交卷吗？
        </div>
        <div class="operate">
          <button @click="btnCancel" class="uc-btn black">取消</button>
          <button @click="btnSubmitSure" class="uc-btn blue">确定</button>
        </div>
      </div>
    </div>

    <div class="uc-alert uc-alert-examSubmitSure result" v-show="showResult">
      <div class="over-close"></div>
      <div class="box">
        <div class="con">
          <div
            class="title yes"
            v-if="resultModel.score_way == 1 && resultModel.is_pass"
          >
            你成功通过本次考试！
          </div>
          <div
            class="title no"
            v-if="resultModel.score_way == 1 && !resultModel.is_pass"
          >
            你未能通过本次考试！
          </div>
          <div class="title" v-if="resultModel.score_way == 2">
            本试卷需要手工评分！
          </div>
          <div class="item">通过分数: {{ this.resultModel.pass_score }}</div>
          <div class="item" v-if="resultModel.score_way == 1">
            考生得分: {{ this.resultModel.auto_score }}
          </div>
          <div class="item" v-if="resultModel.score_way == 2">
            自动判题得分: {{ this.resultModel.auto_score }}
          </div>
        </div>
        <div class="operate">
          <button @click="btnClose" class="uc-btn blue">结束考试</button>
        </div>
      </div>
    </div>
    <Photo
      title="考试拍照"
      v-if="model.camera && !showResult"
      v-show="showCamera"
      @snap="take_snapshot"
    />
  </div>
</template>

<script>
import Photo from '@/components/Photo.vue';

export default {
  name: 'ExamAnswer',
  components: { Photo },
  data() {
    return {
      showCard: false,
      submitSure: false,
      remainder: '--',
      query: {
        id: this.$route.params.id,
        from: this.$route.query.from,
        fromId: this.$route.query.fromId,
      },
      model: {},
      showResult: false,
      resultModel: {},
      showIndex: 0,
      showIndex2: 0,
      showCamera: false,
    };
  },
  created() {
    this.loadData();
    window.onselectstart = () => {
      return false;
    };
  },
  methods: {
    loadData() {
      this.getPaper();
    },
    async getPaper() {
      const response = await this.$api.exam.getPaper(this.query);
      const { code, message, data } = response.data;
      if (code === 200) {
        this.model = data;
        // 属于限时考试才需要倒计时
        if (this.model.duration > 0) {
          const showTime = () => {
            const remainder =
              this.model.remainder > 0 ? this.model.remainder : 0;
            this.remainder = this.$utils.formatSeconds(remainder);
            if (this.model.remainder > 0) {
              this.model.remainder--;
              setTimeout(showTime, 1000);
            } else {
              // 超时自动提交
              this.submitAnswer();
            }
          };
          showTime();
        }
        if (this.model.remainder > 0) {
          // 切屏提交
          if (this.model.blur) {
            window.onblur = () => {
              if (!this.showResult) {
                this.autoSubmit();
              }
            };
          }
          // 摄像头监考
          if (this.model.camera) {
            this.showCamera = true;
            setInterval(() => {
              this.showCamera = true;
            }, this.model.camera_interval * 60 * 1000);
          }
        }
      } else {
        this.alertMessage('warning', message, true);
      }
    },
    // 提交答卷
    async submitAnswer() {
      const response = await this.$api.exam.submitAnswer({
        answer_id: this.model.answer_id,
        is_required: this.$route.query.isRequired,
        answer_list: this.getAnswerList(),
      });
      const { code, message, data } = response.data;
      if (code === 200) {
        this.showResult = true;
        this.resultModel = data;
      } else {
        this.alertMessage('warning', message, true);
      }
    },
    // 答题卡显示/隐藏
    btnShowCard() {
      this.showCard = !this.showCard;
    },
    // 答题卡点击
    btnCardClick(index, index2) {
      this.goToQuestion(index, index2);
      this.showCard = false;
    },
    // 题目跳转
    goToQuestion(index, index2) {
      if (this.model.page_mode === 1) {
        const top = document.getElementById(`question_${index}_${index2}`)
          .offsetTop;
        window.scrollTo(0, top - 172);
      } else {
        this.showIndex = index;
        this.showIndex2 = index2;
      }
    },
    // 上一题
    btnPrevQuestion() {
      if (
        this.model.question_type_list[this.showIndex].question_list[
          this.showIndex2 - 1
        ]
      ) {
        this.showIndex2--;
      } else if (this.model.question_type_list[this.showIndex - 1]) {
        this.showIndex--;
        this.showIndex2 =
          this.model.question_type_list[this.showIndex].question_list.length -
          1;
      }
    },
    // 下一题
    btnNextQuestion() {
      if (
        this.model.question_type_list[this.showIndex].question_list[
          this.showIndex2 + 1
        ]
      ) {
        this.showIndex2++;
      } else if (this.model.question_type_list[this.showIndex + 1]) {
        this.showIndex++;
        this.showIndex2 = 0;
      }
    },
    // 显示提交确认框
    btnShowSubmitSure() {
      this.submitSure = true;
    },
    // 确定交卷
    btnSubmitSure() {
      this.submitAnswer();
      this.submitSure = false;
    },
    // 取消交卷
    btnCancel() {
      // 如果未答完，则跳转到第一个未答完的题目
      if (this.model.question_count > this.model.answer_count) {
        const getIndex = () => {
          let i = 0;
          for (const item of this.model.question_type_list) {
            let j = 0;
            for (const item2 of item.question_list) {
              if (item2.user_answer_status !== 1) {
                return [i, j];
              }
              j++;
            }
            i++;
          }
        };
        this.goToQuestion.apply(this, getIndex());
      }
      this.submitSure = false;
    },
    // 获取作答数据
    getAnswerList() {
      const answerArr = [];
      for (const item of this.model.question_type_list) {
        for (const item2 of item.question_list) {
          answerArr.push({
            id: item2.id,
            result: item2.user_answer,
          });
        }
      }
      return answerArr;
    },
    // 保存答案
    saveAnswer(item) {
      console.log(item.user_answer);
      if (item.user_answer && item.user_answer.length > 0) {
        // 填空题需要特殊处理
        if (item.question_type === 4) {
          let emptyCount = 0;
          for (const answer of item.user_answer) {
            if (!answer) {
              emptyCount++;
            }
            if (emptyCount === 0) {
              item.user_answer_status = 1;
            } else if (emptyCount < item.user_answer.length) {
              item.user_answer_status = 2;
            }
          }
        } else {
          item.user_answer_status = 1;
        }
      }
      this.$api.exam.saveAnswer({
        answer_id: this.model.answer_id,
        id: item.id,
        result: item.user_answer,
      });
      this.updateProgress();
    },
    // 更新作答进度
    updateProgress() {
      let answerCount = 0;
      for (const item of this.model.question_type_list) {
        for (const item2 of item.question_list) {
          if (item2.user_answer_status === 1) {
            answerCount++;
          }
        }
      }
      this.model.answer_count = answerCount;
      if (this.model.question_count > 0) {
        this.model.answer_percent = Math.floor(
          (this.model.answer_count / this.model.question_count) * 100
        );
      }
    },
    // 结束考试
    btnClose() {
      window.opener = null;
      window.open('about:blank', '_top').close();
    },
    alertMessage(action, msg, isClose) {
      this.$message({
        type: action,
        message: msg,
        onClose: () => {
          if (isClose) {
            window.opener = null;
            window.open('about:blank', '_top').close();
          }
        },
      });
    },
    // 切屏自动提交
    async autoSubmit() {
      const response = await this.$api.exam.submitPrompt({
        answer_id: this.model.answer_id,
      });
      const { code, message, data } = response.data;
      if (code === 200 && data > 0) {
        alert(message);
        if (data === 2) {
          this.submitAnswer();
        }
      }
    },
    // 拍照
    take_snapshot(file) {
      const formData = new FormData();
      formData.append('id', this.model.answer_id);
      formData.append('file', file);
      this.$api.exam
        .takePhoto(formData)
        .then((response) => {
          this.showCamera = false;
        })
        .catch((error) => {
          console.log(error);
          this.showCamera = false;
        });
    },
  },
};
</script>
